<script lang="ts">
    export let client: any;
</script>

<svelte:head>
    <title>Halaman Tidak Ditemukan - {client?.name}</title>
    <!-- <meta property="og:url" content={window.location.href} />
  <meta property="og:type" content="website" />
  <meta property="og:title" content={campaignDetail?.title} />
  <meta property="og:image" content={campaignDetail?.cover} />    -->
    <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`${client?.favicon === null ? "/favicon-32x32.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href={`${client?.favicon === null ? "/favicon-96x96.png" : client?.favicon}`}
    />
    <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`${client?.favicon === null ? "/favicon-16x16.png" : client?.favicon}`}
    />
</svelte:head>

<div class="hero min-h-auto container mx-auto">
    <div class="hero-content text-center">
        <div class="max-w-lg mx-auto">
            <figure>
                <img loading="lazy" src="/nodata.webp" alt="error" />
            </figure>
            <p class="text-black">Data tidak ditemukan</p>
        </div>
    </div>
</div>
